function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("rect", {
  x: 14,
  width: 42.258,
  height: 36.41,
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  y: 15,
  width: 69.258,
  height: 36.41,
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "c"
}, /*#__PURE__*/React.createElement("rect", {
  width: 69.258,
  height: 56.41,
  fill: "#292eff"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M431.828,480.476a16.1,16.1,0,1,1,16.1-16.1,16.118,16.118,0,0,1-16.1,16.1Zm0-27.811a11.71,11.71,0,1,0,11.71,11.71,11.722,11.722,0,0,0-11.71-11.71Zm0,0",
  transform: "translate(-399.522 -432.674)",
  fill: "#0078d7"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M560.43,592.17a2.366,2.366,0,0,1-1.552-.555l-9.415-8.119a1.716,1.716,0,0,1,0-2.679,2.452,2.452,0,0,1,3.106,0l9.415,8.119a1.716,1.716,0,0,1,0,2.679,2.382,2.382,0,0,1-1.555.555Zm0,0",
  transform: "translate(-508.263 -540.98)",
  fill: "#292eff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M364,360",
  transform: "translate(-357.259 -355.475)",
  fill: "#292eff"
}));

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42.258,
    height: 36.41,
    viewBox: "0 0 42.258 36.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14)",
    clipPath: "url(#a)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-52 -76)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 61)",
    clipPath: "url(#b)",
    style: {
      isolation: "isolate"
    }
  }, _ref3, _ref4))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.143c2ffb.svg";
export { ForwardRef as ReactComponent };